import { render, staticRenderFns } from "./MarketOptions.vue?vue&type=template&id=4d458c36&scoped=true&"
import script from "./MarketOptions.vue?vue&type=script&lang=js&"
export * from "./MarketOptions.vue?vue&type=script&lang=js&"
import style0 from "./MarketOptions.vue?vue&type=style&index=0&id=4d458c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d458c36",
  null
  
)

export default component.exports